import { Portal } from '@radix-ui/react-dialog';

export const SheetPortal = Portal;
